import ResizeObserver from 'resize-observer-polyfill';
import { onMounted, onBeforeUnmount } from 'vue';

export function useResizeObserver(elRef, callback) {
    let observer;

    onMounted(() => {
        if (elRef.value) {
            observer = new ResizeObserver((entries) => {
                // eslint-disable-next-line no-restricted-syntax
                for (const entry of entries) callback(entry);
            });
            observer.observe(elRef.value);
        }
    });

    onBeforeUnmount(() => {
        if (observer && elRef.value) {
            observer.unobserve(elRef.value);
            observer.disconnect();
        }
    });
}
